import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../pages/home/home.vue'
import Exhibit from '../pages/exhibit/exhibit.vue'
import Zpxq from '../pages/zpxq/zpxq.vue'
import NewProducts from "../pages/newProducts/index.vue";
import Sczpxq from "../pages/sccp/index.vue"
import Exhibitor from '../pages/exhibitor/exhibitor.vue'
import Zsxq from '../pages/zsxq/zsxq.vue'
import Supply from '../pages/supply/supply.vue'

import User from "../pages/user/user.vue"
import MerchantsCollection from "../pages/userchildren/merchantsCollection/merchantsCollection.vue";
import GoodsCollection from "../pages/userchildren/goodsCollection/goodsCollection.vue";
import IntentionOrder from "../pages/userchildren/intentionOrder/intentionOrder.vue";
import AboutGoods from "../pages/userchildren/aboutGoods/aboutGoods.vue";
import AboutAudience from "../pages/userchildren/aboutAudience/aboutAudience.vue";
import PurchaseManagement from "../pages/userchildren/purchaseManagement/purchaseManagement.vue";
import SupplyManagement from "../pages/userchildren/supplyManagement/supplyManagement.vue";
import Comments from "../pages/userchildren/comments/comments.vue";
import Consulting from "../pages/userchildren/consulting/consulting.vue";



Vue.use(VueRouter)
const Router = new VueRouter({
  mode: 'hash',
  // mode: 'history',
  routes:[
    {//展品
      path:'/exhibit/',
      component:Exhibit,
    },
    {//展品详情
      path:'/exhibit/details/:id/:ocid',
      component:Zpxq,
    },
    {// 首发首创产品或技术
      path:'/newProducts',
      component:NewProducts,
    },
    {//首发首创详情
      path:'/newProducts/details/:id',
      component:Sczpxq,
    },
    {//展商
      path:'/exhibitor/',
      component:Exhibitor,
    },
    {//展商详情
      path:'/exhibitor/details/:id/:ocid',
      component:Zsxq,
    },
    {//供需
      path:'/supply',
      component:Supply,
    },
    {//首页
      path:'/',
      component:Home,
    },
    {//首页
      path:'/home',
      component:Home,
    },
    {//我的
      path:'/user',
      component:User,
      children:[
        {//我的-意向订单
          path:'intentionOrder',
          component:IntentionOrder
        },
        {//我的-展商收藏
          path:'merchantsCollection',
          component:MerchantsCollection
        },
        {//我的-展品收藏
          path:'goodsCollection',
          component:GoodsCollection
        },
        
        {//我的-已约展商
          path:'aboutGoods',
          component:AboutGoods
        },
        {//我的-观众邀约
          path:'aboutAudience',
          component:AboutAudience
        },
        {//我的-采购管理
          path:'purchaseManagement',
          component:PurchaseManagement
        },
        {//我的-供应管理
          path:'supplyManagement',
          component:SupplyManagement
        },
        {//我的-我的评论
          path:'comments',
          component:Comments
        },
        {//我的-询盘咨询
          path:'consulting',
          component:Consulting
        },
      ]
    },
    {
      path:'/ceshi',
      component:IntentionOrder,
    }
  ],
  scrollBehavior () {
    return {x:0,y:0}
  }
})
export default Router